import { createUseStyles } from 'react-jss';


import Spinner from "../../images/spinner.svg";

var styles = {
  spinner: function spinner(props) {return {
      background: {
        image: "url(".concat(Spinner, ")"),
        position: ['center', 'center'],
        repeat: 'no-repeat',
        size: props.size || '10rem'
      },
      width: '100%',
      height: '100%'
    };}
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map